import {createSelector} from 'reselect';
import {getMaximumAlbumPrice, getMaximumTrackPrice} from '../../services/currencies/currencies';
import {albumSelector, trackSelector} from './index';

export const priceSelector = createSelector([albumSelector, trackSelector], (album, track) =>
  Number(track ? track.trackPrice : album.albumPrice),
);
export const priceOverrideSelector = (state) => state.priceOverride;
export const finalPriceSelector = createSelector([priceOverrideSelector, priceSelector], (priceOverride, price) =>
  priceOverride !== undefined ? priceOverride : price,
);

export const currencySelector = createSelector([albumSelector], (album) => album.albumCurrency);

export const maxPriceSelector = createSelector(
  [albumSelector, trackSelector, currencySelector],
  (album, track, currency) => {
    return track ? getMaximumTrackPrice(currency) : getMaximumAlbumPrice(currency);
  },
);
